import $ from 'jquery';
import _ from 'underscore';
import { helpers } from '@bingads-webui/projection-grid-toolbar';
import { getGridName } from '@bingads-webui-campaign/inline-download-grids-metadata';
import { crossPageSelectHeadRow } from '@bingads-webui/projection-grid-cross-page-select-all';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { validateOrder, handleShowRejectionReasonEnter, handleShowRejectionReasonLeave } from '@bingads-webui-campaign/summary-grid-helper';
import { getColumnsConfig } from './columns/index';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/ads-tab');
const stateManager = globalContext.require('StateManager/CampaignStateManager');
const preferenceService = globalContext.requireDefault('component/preference/service/index');
const config = globalContext.require('component/config/index');

const { toolbarRow } = helpers;

export function getConfig({
  dataSource,
  scope,
  view,
  filterService,
  preferenceConfig,
  router,
  isForVNext,
  newI18n,
  viewport,
  customHeaderOffset,
  deps,
  shouldSendOpportunityLog,
  logOpportunity,
  adsTabPerfMarker,
  serverContext,
  isDataFetchManagerSource = false,
  loadClipchampPlayer,
}) {
  const headRows = isForVNext
    ? ['column-header-rows'] : [
      toolbarRow('lower-toolbar'),
      crossPageSelectHeadRow(),
      'column-header-rows',
    ];

  const permissions = config.get('Permissions');
  const events = isForVNext ? {
    'click .linkToAssets': view.onLinkToAssets.bind(view),
    'click .labels-cell-container #see-all': view.onLabelsRowClicked.bind(view),
    'click .labels-cell-item': view.onLabelClicked.bind(view),
    'click .manage-labels-button': view.onManageLabelsClicked.bind(view),
    'click .delivery_status_with_reject_reasons': _.debounce(view.showRejectionReason.bind(view), 50),
    'click .ad-strength': _.debounce(view.showAdStrengthPopup.bind(view), 50),
    'mouseenter .ad-strength': _.debounce(view.showAdStrengthPopup.bind(view), 50),
    'mouseenter .delivery_status_with_reject_reasons': permissions.IsDeferredHoveringPopupEnabled ? _.partial(handleShowRejectionReasonEnter, view, view.showRejectionReason) : _.debounce(view.showRejectionReason.bind(view), 50),
    'mouseleave .delivery_status_with_reject_reasons': permissions.IsDeferredHoveringPopupEnabled ? _.partial(handleShowRejectionReasonLeave, null, _.noop) : null,
    'click .ads_type_exta_deprecate_reasons': _.debounce(view.showDeprecateReason.bind(view), 50),
    'mouseenter .ads_type_exta_deprecate_reasons': _.debounce(view.showDeprecateReason.bind(view), 50),
    'click .ads_type_sta_deprecate_reasons': _.debounce(view.showDeprecateReason.bind(view), 50),
    'mouseenter .ads_type_sta_deprecate_reasons': _.debounce(view.showDeprecateReason.bind(view), 50),
    'mouseleave .grid-column-Delivery': _.debounce(view.hideRejectionPopup.bind(view), 50),
    'mouseleave [data-column="AdType"]': _.debounce(view.hideDeprecatePopover.bind(view), 50),
    'mouseleave .ad-strength': _.debounce(view.hideAdStrengthPopup.bind(view), 50),
  } : {
    'click .linkToAssets': view.onLinkToAssets.bind(view),
    'click .labels-cell-container a': view.onLabelsRowClicked.bind(view),
    'click .delivery_status_with_reject_reasons': view.showRejectionReason.bind(view),
    'click .ads_type_exta_deprecate_reasons': view.showDeprecateReason.bind(view),
    'click .ads_type_sta_deprecate_reasons': view.showDeprecateReason.bind(view),
  };

  const tableName = i18n.getString('EntityType_Ad_Plural');

  const enableGridFlexLayout = _.result(permissions.dynamic, 'GridFlexLayout', false) && isForVNext;
  const gridName = getGridName('Ad');

  const gridConfig = {
    name: gridName,
    legacyGridName: 'AdGrid',
    tableClasses: enableGridFlexLayout ? ['table'] : ['table', 'table-bordered'],
    tableAttributes: { 'aria-label': newI18n.getString(_TL_('{{tableName}} table'), { tableName }) },
    dataSource,
    selection: true,
    filterService,
    rows: {
      headRows,
    },
    columns: getColumnsConfig({
      i18n,
      newI18n,
      scope,
      view,
      showExperiment: config.get('Permissions').IsExperimentsEnabled,
      permissions,
      routeTemplate({
        cid,
        aid,
        cmpid,
        adgid,
      }) {
        if (isForVNext) {
          return adgid
            ? `/campaign/vnext/ads?aid=${aid}&cid=${cid}&campaignId=${cmpid}&adGroupId=${adgid}`
            : `/campaign/vnext/ads?aid=${aid}&cid=${cid}&campaignId=${cmpid}`;
        }
        if (adgid) {
          return `#customer/${cid}/account/${aid}/campaign/${cmpid}/adgroup/${adgid}/ad`;
        }
        return `#customer/${cid}/account/${aid}/campaign/${cmpid}/ad`;
      },
      router,
      isForVNext,
      deps,
      shouldSendOpportunityLog,
      logOpportunity,
      adsTabPerfMarker,
      serverContext,
      preferenceService,
      loadClipchampPlayer,
    }),
    scrolling: {
      header: {
        type: 'sticky',
        offset: customHeaderOffset || (() => $('nav.navbar-default.navbar-fixed-top').height()),
        attributes: {
          'aria-label': i18n.getString('{{tableName}} table header', { tableName }),
          role: 'rowgroup',
        },
      },
      virtualized: true,
    },
    stateManager,
    preferenceService,
    config,
    events,
    isDataFetchManagerSource,
    ...enableGridFlexLayout && { layout: 'flex' },
  };

  validateOrder(preferenceConfig, gridConfig.columns, gridName, permissions);

  if (viewport) {
    gridConfig.scrolling.viewport = viewport;
  }

  return gridConfig;
}
